// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* remove all prev styles from container */
.email-container {
  margin: 10px 0;
  min-height: initial;
  font-size: 15px;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #b7b7b7;
  font-family: sans-serif;
  color: black;
}

/* reset CSS in email preview */
.email-container p {
  display: block;
  font-size: initial;
  line-height: initial;
  margin: initial;
  padding: 3px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-activities/feed-item/activity-email.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;AACd;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;AACd","sourcesContent":["/* remove all prev styles from container */\n.email-container {\n  margin: 10px 0;\n  min-height: initial;\n  font-size: 15px;\n  padding: 10px;\n  background-color: #fff;\n  border: 1px solid #b7b7b7;\n  font-family: sans-serif;\n  color: black;\n}\n\n/* reset CSS in email preview */\n.email-container p {\n  display: block;\n  font-size: initial;\n  line-height: initial;\n  margin: initial;\n  padding: 3px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
